import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { registerSW } from "virtual:pwa-register";
import { Providers } from "@/app/providers";
import { routes } from "@/app/routes";
import { listenForInstall, setupUpdates } from "@/lib/pwa";
import "./index.css";

const router = createBrowserRouter(routes);

// A new deploy shows an "update ready" toast; the install prompt is kept for Settings.
setupUpdates(registerSW);
listenForInstall();

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<Providers>
			<RouterProvider router={router} />
		</Providers>
	</StrictMode>,
);
